import WizardRegistrationPassword from './container'
export { WizardRegistrationPassword }
export default WizardRegistrationPassword